import React from 'react'
import './Landing.scss'
// import landingImage from '../../Images/landingimage.png'

function Landing() {
  return (
    <div id='landing' className='landingGrid'>
        <div>
            <h2>Erupt <span style={{color: '#FF8329'}}>Proxies</span></h2>
            <h1>Speed, Stealth and Reliability.</h1>
            <div className='buttonGroup'>
                <a href="" className='btn buyButton'>Explore Plans</a>
                <a href="" className='btn learnButton'>Learn More</a>
            </div>
        </div>

        <div className='analytics'>
            <div className='analyticCard'>
                <h3>100k+</h3>
                <p>active users</p>
            </div>
            <div className='borderLine' />
            <div className='analyticCard'>
                <h3>100M+</h3>
                <p>proxies generated</p>
            </div>
            <div className='borderLine' />
            <div className='analyticCard'>
                <h3>100k+</h3>
                <p>active users</p>
            </div>
        </div>
    </div>
  )
}

export default Landing